import {PageFilter} from 'filters/types';

export const clearFilterType = <T extends PageFilter>(filter: T): Omit<T, '_type'> => ({
  ...filter,
  _type: undefined,
});

export const clearStoredId = <T extends PageFilter>(filter: T): Omit<T, 'storedId'> => {
  return {
    ...filter,
    storedId: undefined,
  };
};

export const clearFilter = <T extends PageFilter>(filter: T): Omit<T, '_type' | 'storedId'> => {
  return {
    ...filter,
    storedId: undefined,
    _type: undefined,
  };
};
